module.exports = require("babel-runtime/core-js/object/get-prototype-of");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/core-js/object/get-prototype-of"
// module id = 8
// module chunks = 0 1 2 3 4 5 6 7